var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.25 12.125C8.25 10.4681 9.59315 9.125 11.25 9.125H18.75C20.4069 9.125 21.75 10.4681 21.75 12.125V13.25V20C21.75 21.6569 20.4069 23 18.75 23H11.25C9.59315 23 8.25 21.6569 8.25 20V13.25V12.125Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.125H11.25C9.59315 9.125 8.25 10.4681 8.25 12.125V13.25H21.75V12.125C21.75 10.4681 20.4069 9.125 18.75 9.125Z",
    fill: "#DE8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.4375C12.3107 7.4375 12.5625 7.68934 12.5625 8V10.25C12.5625 10.5607 12.3107 10.8125 12 10.8125C11.6893 10.8125 11.4375 10.5607 11.4375 10.25V8C11.4375 7.68934 11.6893 7.4375 12 7.4375ZM18 7.4375C18.3107 7.4375 18.5625 7.68934 18.5625 8V10.25C18.5625 10.5607 18.3107 10.8125 18 10.8125C17.6893 10.8125 17.4375 10.5607 17.4375 10.25V8C17.4375 7.68934 17.6893 7.4375 18 7.4375Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDate);
export default __webpack_public_path__ + "static/media/menu_date.f4826da59764a5e204759d11ac5c3bfa.svg";
export { ForwardRef as ReactComponent };